import React from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import Avatar from '@material-ui/core/Avatar';

import useBusStopListItemStyles from './useBusStopListItemStyles';

const BusStopListItem = (props) => {
    const { 
        id, 
        name, 
        onStopClick 
    } = props;
    const classes = useBusStopListItemStyles(props);

    const onStopClickHandler = () => {
        onStopClick({
            stopId: id,
            stopName: name
        });
    };

    const avatarText = name.charAt(0).toUpperCase();

    return (
        <ListItem button onClick={onStopClickHandler}>
            <ListItemAvatar>
                <Avatar className={classes.avatar}>{avatarText}</Avatar>
            </ListItemAvatar>
            <ListItemText primary={name} secondary={`#${id}`} />
        </ListItem>
    );
}

export default BusStopListItem;